import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { useFilter } from "../../FilterContext";
import "./FilterSidebar.css";

const FILTER_CONFIG = [
  { fieldName: "demographic_category_01", displayName: "Location" },
  { fieldName: "demographic_category_02", displayName: "Department" },
  { fieldName: "demographic_category_03", displayName: "Functional Area" },
  { fieldName: "demographic_category_04", displayName: "Job Classification" },
  { fieldName: "demographic_category_05", displayName: "Tenure" },
  { fieldName: "demographic_category_06", displayName: "Generation" },
  { fieldName: "demographic_category_07", displayName: "Gender" },
  { fieldName: "demographic_category_08", displayName: "Manager Name" },
  { fieldName: "demographic_category_09", displayName: "Race" },
  { fieldName: "demographic_category_10", displayName: "Employee Type" },
];

const FilterSidebar = ({
  isOpen,
  filterOptions = {},
  onFiltersInitialized,
}) => {
  const { filterCriteria, setFilterCriteria } = useFilter();
  const [filtersInitialized, setFiltersInitialized] = useState(false);

  useEffect(() => {
    // Initialize filters on component mount
    setFilterCriteria((prev) => ({
      ...prev, // Preserve any existing filters
    }));
    setFiltersInitialized(true); // Indicate filters are ready
    if (onFiltersInitialized) onFiltersInitialized();
  }, [setFilterCriteria, onFiltersInitialized]);

  const handleMultiSelectChange = (selectedOptions, actionMeta) => {
    const { name } = actionMeta;
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilterCriteria((prevState) => ({
      ...prevState,
      [name]: selectedValues.includes("all") ? [] : selectedValues,
    }));
  };

  const createOptions = (items = []) => [
    { value: "all", label: "Select All" },
    ...items.map((item) => ({ value: item, label: item })),
  ];

  const getSelectedOptions = (selectedValues = [], items = []) => {
    if (!selectedValues.length || !items.length) return [];
    if (
      selectedValues.includes("all") ||
      selectedValues.length === items.length
    ) {
      return [{ value: "all", label: "All selected" }];
    }
    return createOptions(items).filter((option) =>
      selectedValues.includes(option.value)
    );
  };

  const clearAllFilters = () => {
    const clearedCriteria = FILTER_CONFIG.reduce((acc, config) => {
      acc[config.fieldName] = [];
      return acc;
    }, {});
    setFilterCriteria(clearedCriteria);
  };

  return (
    filtersInitialized && (
      <div
        className={`filter-sidebar ${
          isOpen ? "filter-sidebar-open" : "filter-sidebar-closed"
        }`}
      >
        <div className="filter-sidebar-content">
          {FILTER_CONFIG.map(({ fieldName, displayName }) => (
            <div key={fieldName}>
              <label htmlFor={fieldName}>{displayName}:</label>
              <Select
                name={fieldName}
                options={createOptions(filterOptions[fieldName] || [])}
                isMulti
                onChange={handleMultiSelectChange}
                value={getSelectedOptions(
                  filterCriteria[fieldName],
                  filterOptions[fieldName] || [],
                  fieldName
                )}
              />
            </div>
          ))}
        </div>
        <button onClick={clearAllFilters} className="clear-all-button">
          Clear All
        </button>
      </div>
    )
  );
};

FilterSidebar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  filterOptions: PropTypes.object.isRequired,
  onFiltersInitialized: PropTypes.func, // Optional callback when filters are ready
};

export default FilterSidebar;
